module.exports = __webpack_public_path__ + "static/media/A24.8abb9019.png";